import { Prose } from '../components/Prose';
import { Reveal } from '../components/Reveal';
import { Accent, SectionHeading } from '../components/SectionHeading';
import { pullQuote, storyParagraphs } from '../content/story';

export function Story() {
  return (
    <section className="px-6 py-24 sm:px-8 sm:py-28">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <SectionHeading eyebrow="A little about me">
            Why I do <Accent>this work</Accent>.
          </SectionHeading>
        </Reveal>

        <div className="mt-10 space-y-6 text-lg leading-relaxed">
          {storyParagraphs.map((paragraph, index) => (
            <Reveal key={index} delay={index * 120} as="p">
              <Prose segments={paragraph} />
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <figure className="relative mt-12 rounded-blob bg-mint-50 px-8 py-10 text-center shadow-soft sm:px-12">
            <span
              aria-hidden="true"
              className="absolute top-3 left-6 font-display text-7xl leading-none text-mint-200 select-none"
            >
              &ldquo;
            </span>
            <blockquote className="relative font-display text-xl leading-relaxed font-semibold text-mint-900 sm:text-2xl">
              <Prose segments={pullQuote} />
            </blockquote>
            <figcaption className="mt-8 flex justify-center">
              <img
                src="/images/signature.png"
                alt="Courtney"
                width={1340}
                height={523}
                className="h-14 w-auto"
              />
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
